// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { getInitialQuickAddValues } from '../helpers'
import { changeOpenPanel } from 'redux/modules/projectSummary'

const handleChangeOpenPanel = newPanelName => (dispatch, getState) => {
  const { projectSummary } = getState()
  const unitType = projectSummary.get('unitType')

  // reset forms before displaying - could contain persisting values or errors
  switch (newPanelName) {
    case 'quick-add' :
      dispatch(
        initialize('quick-add-path',
          getInitialQuickAddValues(unitType)
        ))
      break

    case 'project-settings' :
      dispatch(initialize('project-summary-settings', {
        unitType,
        defaultCompanyId: projectSummary.getIn(['defaultCompany', 'companyId']) || '',
        serviceContactCode: projectSummary.getIn(['defaultContact', 'contactCode']) || '',
        defaultContactId: projectSummary.getIn(['defaultContact', 'contactId']) || '',
      }))
      break

    default :
      break
  }
  dispatch(changeOpenPanel(newPanelName))
}

export default handleChangeOpenPanel
